<nb-card>
  <nb-card-header>
    <div class="summary">
      <ngx-view-time-period
        (periodChange)="selectTime($event)"
      ></ngx-view-time-period>

      <ngx-card-value-overview
        [title]="'receipt.receiptCount' | translate"
        [value]="receipts.length"
        [type]="'info'"
        [icon]="'layers-outline'"
      >
      </ngx-card-value-overview>

      <ngx-card-value-overview
        [title]="'receipt.totalAmount' | translate"
        [value]="totalAmount"
        [type]="'success'"
        [icon]="'arrow-circle-up-outline'"
      >
      </ngx-card-value-overview>

      <ngx-card-value-overview
        [title]="'common.cancel' | translate"
        [value]="cancelAmount"
        [type]="'danger'"
        [icon]="'arrow-circle-down-outline'"
      >
      </ngx-card-value-overview>
    </div>

    <div class="form-inline">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="{{ 'common.strSearch' | translate }}"
          [(ngModel)]="strSearch"
        />
      </nb-form-field>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="row">
      <div
        *ngFor="let item of receipts | filter: strSearch; let i = index"
        class="col-md-12"
      >
        <ngx-view-receipt
          [shopId]="shopId"
          [receipt]="item"
          [mode]="'report'"
          (onDelete)="onDelete($event)"
        ></ngx-view-receipt>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      nbButton
      shape="semi-round"
      outline
      status="danger"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
      <span>{{ "buttons.close" | translate }}</span>
    </button>
  </nb-card-footer>
</nb-card>
